"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MailIcon_1 = require("./MailIcon");
exports.MailIcon = MailIcon_1.MailIcon;
//# sourceMappingURL=index.js.map